import { Box } from '@mui/material';
import { Outlet, ScrollRestoration } from 'react-router';
import { ArticleProvider } from './ArticleContext';

export default function ArticlePageContainer() {
  return (
    <Box>
      <ArticleProvider>
        <Box id='article'>
          <ScrollRestoration />
          <Outlet />
        </Box>
      </ArticleProvider>
    </Box>
  );
}
